import type { SourceCheck } from "@/mocks/events";

export default function SourceCheckBlock({ check }: { check: SourceCheck }) {
  return (
    <section id="sec-source" className="scroll-mt-20">
      <div className="rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-8">
        <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-search-eye-line" aria-hidden="true"></i>
          </span>
          信息溯源清单
        </h2>
        <p className="mt-2 text-sm text-foreground-700">
          把「证据强度」分层是这份地图的核心。以下内容仅基于公开信源归纳，供交叉验证参考。
        </p>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="rounded-lg bg-background-50 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-check-line text-xs" aria-hidden="true"></i>
              </span>
              已证实 · 有可靠信源支撑
            </h3>
            <ul className="mt-3 space-y-2.5">
              {check.verified.map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-600" aria-hidden="true"></i>
                  {v}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-50 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-300 text-secondary-900">
                <i className="ri-alarm-line text-xs" aria-hidden="true"></i>
              </span>
              未证实 · 待进一步核实
            </h3>
            <ul className="mt-3 space-y-2.5">
              {check.unverified.map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-error-warning-line mt-0.5 shrink-0 text-secondary-500" aria-hidden="true"></i>
                  {v}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-5 rounded-lg bg-primary-50 px-4 py-3 text-xs leading-relaxed text-primary-800">
          提醒：任何截图、报价与聊天记录都可能被断章取义，请尽量回到一手来源核验，再决定是否表态或转发。
        </p>
      </div>
    </section>
  );
}